export var ACTION;
(function (ACTION) {
    ACTION["TEST_ACTION"] = "TEST_ACTION";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["CLOSE_POP_UP"] = "CLOSE_POP_UP";
    ACTION["SELECT_HAVE_NOT_HAVE_MF"] = "SELECT_HAVE_NOT_HAVE_MF";
    ACTION["INPUT_NAME"] = "INPUT_NAME";
    ACTION["INPUT_PHONE"] = "INPUT_PHONE";
    ACTION["SELECT_PORTFOLIO_VALUE"] = "SELECT_PORTFOLIO_VALUE";
    ACTION["DISABLE_CONTINUE"] = "DISABLE_CONTINUE";
    ACTION["ENABLE_CONTINUE"] = "ENABLE_CONTINUE";
    ACTION["APPLY_NOW"] = "APPLY_NOW";
    ACTION["GET_DIMENSION"] = "GET_DIMENSION";
    ACTION["SELECT_PORFOLIO"] = "SELECT_PORFOLIO";
})(ACTION || (ACTION = {}));
// export type TestActionPayload = {}
